import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";

type Props = {
  id: string;
  register: UseFormRegisterReturn;
  label: string;
  value: string;
  defaultChecked?: boolean;
};
const Radio: React.FC<Props> = (props) => {
  const { id, register, label, value, defaultChecked } = props;

  return (
    <div className="flex">
      <input
        defaultChecked={defaultChecked}
        value={value}
        id={id}
        type="radio"
        {...register}
        className="radio-btn mr-[10px] h-5 w-5 shrink-0 rounded-[50%] border border-[#B1C2CC] relative appearance-none"
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

export default Radio;
